import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { api } from '../services/api';
import authReducer from '../features/auth/authSlice';
import uiReducer from '../features/ui/uiSlice';
import attendanceReducer from '../features/attendance/attendanceSlice';
import { errorToastMiddleware } from './middleware';


export const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        auth: authReducer,
        ui: uiReducer,
        attendance: attendanceReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(api.middleware, errorToastMiddleware),
    devTools: import.meta.env.DEV,
});

// Without this, `refetchOnFocus`/`refetchOnReconnect` (set on the api below)
// are silently no-ops — RTK Query only wires up the window focus/online
// listeners that drive them once this is called. This was missing
// entirely, so a query result cached before an event that changes it
// server-side (e.g. clocking in) would sit stale until something else
// happened to invalidate its tag or the component remounted — someone
// leaving a tab open all day would keep seeing whatever was first fetched.
setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
